import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTypesOfObjectivesAction } from "../actions";
import { getLoading, getData, getTypeList } from "../selectors";
import { getAppColor } from "@icarius-app/selectors";
import { Grid } from "@material-ui/core";
import DataItem from "./data/dataItem";
import { RESET_STATE } from "../actionTypes";
import ABMLayout from "@icarius-common/abmComponents/abmLayout";
import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

const TypesOfObjectives = ({ history }) => {
    const [createIsOpen, setCreateIsOpen] = useState(false);

    const dispatch = useDispatch();
    const color = useSelector(getAppColor);
    const data = useSelector(getData);
    const typeList = useSelector(getTypeList);
    const isLoading = useSelector(getLoading);

    useEffect(() => {
        dispatch(getTypesOfObjectivesAction());
        return () => {
            dispatch({ type: RESET_STATE });
        };
    }, [dispatch]);

    const getDataIsEmpty = () => {
        return !data || data.length === 0;
    };

    const handleGoBack = () => {
        history.push(paths.performanceDefinition);
    };

    return (
        <ABMLayout
            title={getLocalizedString("typesOfObjectives")}
            isLoading={isLoading}
            showCreateButton={!createIsOpen}
            createButtonTitle={getLocalizedString("newObjectiveType")}
            createButtonOnClick={() => setCreateIsOpen(true)}
            showNoData={getDataIsEmpty()}
            noDataTitle={getLocalizedString("noObjectiveTypesFound")}
            noDataCreateTitle={getLocalizedString("newObjectiveType")}
            noDataOnClick={() => setCreateIsOpen(true)}
            showGoBack
            handleGoBack={handleGoBack}
        >
            {createIsOpen && (
                <Grid container item xs={12} style={{ margin: "10px 0px" }}>
                    <DataItem color={color} data={null} typeList={typeList} closeNew={() => setCreateIsOpen(false)} />
                </Grid>
            )}
            {data &&
                data.map((item) => {
                    return (
                        <Grid container item xs={12} style={{ margin: "10px 0px" }} key={item.code}>
                            <DataItem data={item} typeList={typeList} color={color} />
                        </Grid>
                    );
                })}
        </ABMLayout>
    );
};

export default TypesOfObjectives;
